// extracted by mini-css-extract-plugin
export default {"period":"periodText_period__9+n-A","content":"periodText_content__uYq3l"};